import React from "react";
import { Box, Typography } from "@mui/material";
import MoovsDatePicker from "../../../../components/ui/MoovsDatePicker";
import MoovsTimePicker from "../../../../components/ui/MoovsTimePicker";

type FromDateTimeInputProps = {
  value: any;
  onDateChange: (date: any) => void;
  onTimeChange: (time: any) => void;
  disabled?: boolean;
};

function FromDateTimeInput({
  value,
  onDateChange,
  onTimeChange,
  disabled = false,
}: FromDateTimeInputProps) {
  return (
    <>
      <Typography variant="overline">FROM</Typography>
      <Box display="flex" gap={2} mb={2} mt={1}>
        <MoovsDatePicker
          value={value}
          onAccept={onDateChange}
          disabled={disabled}
          renderInputProps={{
            fullWidth: true,
            size: "small",
          }}
        />
        <MoovsTimePicker
          value={value}
          onAccept={onTimeChange}
          disabled={disabled}
          renderInputProps={{
            fullWidth: true,
            size: "small",
          }}
        />
      </Box>
    </>
  );
}

export default FromDateTimeInput;